//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isArray } from 'highcharts'

import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import { createFieldConfig, Store } from '../../components/QSelectUtils.js'
import { axiosGet } from '../../axios/axios.js'
import { formatUniqueToolName } from './stockInventoryTools.js'

export default {
  name: 'StockInventoryToolField',
  components: {
    ItemsSearchField
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    selectionDialogColumns: {
      type: Array,
      default: null
    }
  },
  data: function () {
    const vm = this

    return {
      toolValueSelected: null,
      formatUniqueToolName: formatUniqueToolName,
      toolFieldConfig: createFieldConfig(
        new Store({
          fullReadable: false,
          cached: false,
          searchable: true,
          searchValueMinLength: 1,
          searchFiltrationBySource: true,
          proxy: {
            urlBase: '/service/delta/stockInventory/task/tools?splitByParties=true',
            searchParamKey: 'searchPattern',
            filterType: 'stockInventoryTool',
            formId: 'stockInventoryTaskAdditional',
            get urlParams () {
              const params = {}
              if (vm.record.request.stock) {
                params.stockId = vm.record.request.stock.id
              }
              if (vm.record.request.id && vm.record.request.id != -1) {
                params.requestId = vm.record.request.id
              }
              params.sourceListType = 'all'
              params.sourceListTypeStrict = true
              return params
            },
            mapper: tool => {
              return {
                ...tool,
                _disabled: vm.record.request.toolRecords.some(tR => (tR.tool && tR.tool.uniqueKey) === (tool && tool.uniqueKey)),
                _reasonDisabled: 'Уже есть в списке номенклатуры'
              }
            }
          }
        })
      )
    }
  },
  computed: {
    toolValue: {
      get: function () {
        if (this.toolValueSelected) {
          return this.toolValueSelected
        } else if (this.record) {
          const tool = this.toolRecord.tool
          const id = tool && tool.id || null
          const name = tool && tool.name || null
          if (id || name) {
            return { id, name }
          }
        }
        return null
      },
      set: function (value) {
        this.toolValueSelected = value

        this.$emit('input', value)
      }
    },
    inputValue: function () {
      return this.$refs.toolField && this.$refs.toolField.inputValue
    }
  },
  methods: {
    addCustomValue (val) {
      val = val ? val.trim() : null

      this.findToolByName(val).then(tool => {
        if (tool) {
          this.$q.notify({
            type: 'negative',
            message: 'Номенклатурная позиция "' + val + '" существует',
            progress: true,
            timeout: 10000
          })
        } else {
          this.toolValue = { id: null, name: val }
          this.$refs.toolField.$refs.select.hidePopup()
        }
      })
    },
    onCreateNewValue (val, done, eventType) {
      val = val ? val.trim() : null
      if (eventType === 'keydown' && val) {
        this.findToolByName(val).then(tool => {
          if (tool) {
            this.$q.notify({
              type: 'negative',
              message: 'Номенклатурная позиция "' + val + '" существует',
              progress: true,
              timeout: 10000
            })
          } else {
            done({
              id: null,
              name: val
            })
          }
        })
      }
    },
    onInputValueStarted (updateInputValue) {
      if (this.toolValue && this.toolValue.id == null && this.toolValue.name) {
        updateInputValue(this.toolValue.name)
      }
    },

    /**
     * Для вызова извне
     */
    validate () {
      const tool = this.toolValue
      return this.validateName(tool) === true
    },
    validateName: function (tool) {
      if (tool && isArray(tool)) {
        if (tool.length) {
          tool = tool[0]
        } else {
          tool = null
        }
      }
      if (tool && tool.id == null && tool.name != null) {
        const nameRegExp = /^Неизвестная позиция «(.*)»$/

        let currentToolName = tool.name
        let matchResult = currentToolName.match(nameRegExp)
        if (matchResult) {
          currentToolName = matchResult[1]
        }

        const unknownToolRecords = this.record.request.toolRecords.filter(r => r.id != this.toolRecord.id && (!r.tool || r.tool.id == null))
        for (const unknownToolRecord of unknownToolRecords) {
          let toolName = unknownToolRecord.tool && unknownToolRecord.tool.name || null
          if (toolName) {
            matchResult = toolName.match(nameRegExp)
            if (matchResult && matchResult.length) {
              toolName = matchResult[1]
            }
            if (currentToolName == toolName) {
              return 'Неизвестная позиция с названием "' + currentToolName + '" уже содержится в списке'
            }
          }
        }
      }
      return true
    },

    findToolByName (toolName) {
      const urlParams = new URLSearchParams()
      urlParams.set('name', toolName)

      const target = this
      // target.loading = true
      return axiosGet({
        url: 'service/delta/stockInventory/task/checkToolExist?' + urlParams.toString(),
        onSuccess: (response) => {
          return response.data.result || null
        },
        onFailure: (response) => {
          target.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка поиска номенклатурной позиции',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      })
      // .finally(() => {
      //   target.loading = false
      // })
    }
  }
}

